import { Component, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { CostCenterDto } from 'src/app/models/CostCenterDto';
import { DepartmentDto } from 'src/app/models/DepartmentDto';
import { FunctionDto } from 'src/app/models/FunctionDto';
import { LocationDto } from 'src/app/models/LocationDto';
import { CostCentersService } from 'src/app/services/costcenters.service';
import { DepartmentsService } from 'src/app/services/departments.service';
import { FunctionsService } from 'src/app/services/functions.service';
import { LocationsService } from 'src/app/services/locations.service';
import { NotificationService } from 'src/app/services/notification.service';
import { TokenService } from 'src/app/services/token.service';
import { UserService } from 'src/app/services/user.service';
import { ManpowerRequestVM } from 'src/app/models/requests/ManpowerRequestVM';
import { NotificationType } from 'src/app/models/notification.message';
import { ManPowersService } from 'src/app/services/man-powers.service';
import { Profile } from 'src/app/models/profile';
import { Observable } from 'rxjs/internal/Observable';
import { ReplaySubject } from 'rxjs';
import { ManPowerDraftsService } from 'src/app/services/man-powerDrafts.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-edit-manpower-draft',
  templateUrl: './edit-manpower-draft.component.html',
  styleUrls: ['./edit-manpower-draft.component.css']
})
export class EditManpowerDraftComponent implements OnInit {

   @ViewChild('ngNewManPowerForm') theForm: any;
    currentUser: any;
   // @Output() uploadCount: EventEmitter<number> = new EventEmitter<number>();
    @Input() deleteLink = true;
    @Input() panelTitle = 'Document Uploads';
    @Input() showUploadForm = true; // CHANGED TO showUploadForm
  
    @Input() applicationId!: number;
    @Input() referenceNumber = '';
  
    uploadFileTitle: string = '';
    files!: FileList;
    file!: File;
    fileDocument: any;
    isSelected: boolean = false;
    clicked : boolean = false;
    funcdirectorCount : number = 0;
    hrbpCount : number = 0;
    hrCount : number = 0;
    ceoCount : number = 0;
   
    Locations: LocationDto[] | undefined;
    Functions:FunctionDto[]=[];
    Departments: DepartmentDto[] = [];
    CostCenters: CostCenterDto[] | undefined;
    selectedLocationId: string = ''
    dateVacancyOccured:Date | null = null;
    selectedDepartmentId: string = ''
    selectedPlantManagerId: string = ''
    selectedCostCenterId: string = ''
    selectedFunctionId: string = ''
    description: string = ''
    requesterName: string = ''
    justification: string = '';
    requestorName: string = '';
    ftcdurationofcontract: number = 0;
    ftcestimatedcost: number = 0
    consDurationOfContract: number = 0;
    consEstimatedcost: number = 0;
    internDurationofcontract: number = 0;
    internEstimatedcost: number = 0;
    designation: string = '';
    jobTitle: string = '';
    documentDescription: string = '';
    nPlusOneDsignation: string = '';
    Band: string = '';
    hrbpToApprove: string ='';                 
    ceoToApprove:string ='';
    otherReasonForVacancy: string = '';
    requiredNumber: number | null = null;
    IsPlantManagerToApprove: boolean = false
    typeOfVacancy:  string = '';
    reasonForVacancy: string = '';
    modeOfRecruitment: string = '';
    InternalExternal: string = '';
    DocumentContent: string = '';
    durationofcontract: number = 0;
    estimatedcost: number = 0;
    educationalqualification: string = '';
    skillsrequired: string = '';
    isreasonForVacancyVisible:boolean=false;
    isreasonForVacancy:boolean=false;
    isShowPlantManager:boolean=false;
    experience: string = '';
    draftId: number = 0; 
    systemRequirements: any ={
      BCMIX : false,
      LABMIX : false,
      HOLDIM : false,
      SALESFORCE : false,
      SAP : false
    };
    base64Output: string='';
    FTERequirements: any ={
      InternalMovement : false,
      ExternalNewStaff : false,
      
    };
  
    modeofrecruitments: any ={
      FTEInternalMovement : false,
      FTEExternalNewStaff : false,
    };
    ImageBaseData?:string | ArrayBuffer= undefined;
    
  
    band = [
      { name: "A"},
      {  name: "B"},
      {  name: "C"},
      { name: "D"},
      { name: "E"},
      { name: "F"},
      { name: "F PLUS"},
      { name: "G"},
      { name: "H"},
       { name: "N/A"}
   ];
  
   typeofvacancy = [
    { vacancy: "FTE"},
    //{  vacancy: "FTC"},
    {  vacancy: "CONSULTANT"},
    { vacancy: "INTERNSHIP"},
   
  ];
  
  
  ModeOfrecRuitment = [
    { modeofrecruitments: "FTE"},
    {  modeofrecruitments: "FTC"},
    {  modeofrecruitments: "CONSULTANT"},
    { modeofrecruitments: "INTERNSHIP"},
   
  ];
  
  Reasonforvacancy = [
    { reasonforvacancy: "RESIGNATION"},
    {  reasonforvacancy: "TERMINATION"},
    {  reasonforvacancy: "DISMISSAL"},
    { reasonforvacancy: "RETIREMENT"},
    { reasonforvacancy: " NEW POSITION:"},
    { reasonforvacancy: " TRANSFER"},
   
  ];
    otherRequirements: string='';
    selectedManagerId:string="";
    selectedfunctionalDirectorId:string="";
    Managers:Profile[]=[];
    selectedhrbpId:string="";
    HRBPS:Profile[]=[];
    FunctionalDirectors:Profile[]=[];
    PlantManagers:Profile[]=[];
    ohrdToApprove: string = '';
    //requestDate: Date = new Date;
    requestDate: Date | null = null;
  
    constructor(private locationService: LocationsService,
        private notification: NotificationService,private ManPowerService: ManPowersService, private ManPowerDraftsService: ManPowerDraftsService, private router: Router,
      private costCenterService: CostCentersService,private department: DepartmentsService, private nznotification: NzNotificationService, private tokenService: TokenService,  private userService: UserService,private functionService:FunctionsService,) { }
  
    ngOnInit(): void {
      
      const stateData = history.state.data;
      if (stateData) {
        this.populateForm(stateData);
      }
      this.LoadDropDowns()
      this.draftId = stateData.id;
    }


    populateForm(data: any): void {
      this.requesterName = data.requesterName || '';
      this.designation = data.requesterDesignation || '';
      this.selectedDepartmentId = data.requesterFunction || '';
      this.selectedFunctionId = data.requesterUnit || '';
      this.requestDate = data.requestDate
    ? this.convertToDate(data.requestDate)
    : null;
      this.jobTitle = data.jobTitle || '';
      this.nPlusOneDsignation = data.nPlus1Designation || '';
      this.Band = data.band || '';
      this.selectedCostCenterId = data.costCenter || '';
      this.selectedLocationId = data.location || '';
      this.dateVacancyOccured = data.requestDate
      ? this.convertToDate(data.dateVacancyOccured)
      : null;
      this.requiredNumber = data.requiredNumber || null;
      this.typeOfVacancy = data.typeOfVacancy || '';
      this.reasonForVacancy = data.reasonForVacancy || '';
      this.otherReasonForVacancy = data.reasonForVacancy || '';
      this.selectedManagerId = data.unitHeadToApprove || '';
      this.selectedhrbpId = data.hrbpToApprove || '';
      this.selectedfunctionalDirectorId = data.functionDirectorToApprove || '';
      this.experience = data.experience || '';
      this.educationalqualification = data.qualification || '';
      this.skillsrequired = data.skillsRequired || '';
      this.justification = data.justificationForVacancy || '';
      this.systemRequirements = { ...data.systemRequired };
      this.otherRequirements = data.otherSystemRequirements || '';
      this.modeOfRecruitment = data.modeOfRecruitment || '';
      
    }


    convertToDate(input: any): Date | null {
      if (typeof input === 'string') {
        // Handle string format "yyyy-mm-dd" or "yyyy/mm/dd" and convert to Date object
        const dateParts = input.split(/[-/]/); // Split on both hyphen and slash
        const year = parseInt(dateParts[0], 10);
        const month = parseInt(dateParts[1], 10) - 1; // Months are zero-based in Date object
        const day = parseInt(dateParts[2], 10);
        return new Date(year, month, day); // Return as Date object
      } else if (input instanceof Date) {
        return input; // If already a Date object, return it as-is
      } else {
        return null; // If not valid, return null
      }
    }
    
    
    
  
    onFileChange(event : any) {
    
      this.files = event.target.files;
      this.file = this.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(this.file);
      reader.onload = () => {
          console.log(reader.result);
          this.DocumentContent = reader.result as string
      };
         
    
     // };
  
   
  
      console.log(this.base64Output);
    
       
  }
   
  
  uploadFile() {
    
    if (this.file != undefined || this.uploadFileTitle != null) {
        const body = {
            //  documentId:12332,
            loanApplicationId: this.applicationId,
            loanApplicationNumber: this.referenceNumber,
            loanReferenceNumber: this.referenceNumber,
            documentTitle: this.uploadFileTitle == null ? '' : this.uploadFileTitle,
            fileName: this.file.name,
          //  fileExtension: (this.helperService.fileExtention(this.file.name)).toLowerCase(),
            physicalFileNumber: 'n/a',
            physicalLocation: 'n/a',
            documentTypeId: '1', // TODO: redundant with fileExtension known
            overwrite: false,
        };
        //// console.log('body  >>', body);
  
        // this.loadingService.show();
        // this.documentpUloadService.uploadFile(this.file, body).then((response: any) => {
  
        //     if (response.result === 3) {
        //         body.overwrite = true;
        //         this.confirmOverwrite(body);
        //         this.uploadFileTitle = null;
        //         this.fileInput.nativeElement.value = '';
        //     } else {
        //         this.uploadFileTitle = null;
        //         this.fileInput.nativeElement.value = '';
        //         swal(`${GlobalConfig.APPLICATION_NAME}`, response.message, 'success');
        //         this.getAllUploadedDocument(body);
        //     }
        //     if (response.success === false) {
        //         swal(`${GlobalConfig.APPLICATION_NAME}`, response.message, 'error');
        //     }
        //     this.loadingService.hide();
        // }, (error) => {
  
        //     swal(`${GlobalConfig.APPLICATION_NAME}`, error, 'error');
        //     this.loadingService.hide(1000);
      
    }
  }
  
    MyDrafts(){
      this.router.navigate(['/manpowerdrafts']);
    }
  
    
    async LoadDropDowns() {
  
      
      if (this.isShowPlantManager == false){
        this.funcdirectorCount = 2
        this.hrbpCount = 3
        this.hrCount = 4
        this.ceoCount = 5
      }
      this.currentUser = this.tokenService.getInfo();
      let resLocations = await this.locationService.getLocations().toPromise();
      this.Locations = <LocationDto[]>resLocations.responseData;
      
      let resCostCenterss = await this.costCenterService.getCostCenters().toPromise();
      this.CostCenters = <CostCenterDto[]>resCostCenterss.responseData;
      
      let resDeparts = await this.department.getDepartments().toPromise();
      this.Departments = <DepartmentDto[]>resDeparts.responseData;
  
      
      let functions = await this.functionService.getAllFunctions().toPromise();
      this.Functions = <FunctionDto[]>functions.responseData;
  
      
      let usersPro = await this.userService.getManagersUsers().toPromise();
      this.Managers = <Profile[]>usersPro.responseData;
  
      let userhrpbps = await this.userService.getHRBPS().toPromise();
      this.HRBPS = <Profile[]>userhrpbps.responseData;
  
      let ohrDirector = await this.userService.getOHRDirector().toPromise();
      let ohrDirectorRes = <Profile[]>ohrDirector.responseData;
      this.ohrdToApprove = ohrDirectorRes[0].email;
  
      let ceo = await this.userService.getCEO().toPromise();
      let ceoRes = <Profile[]>ceo.responseData;
      this.ceoToApprove = ceoRes[0].email;
  
      let directors = await this.userService.getFunctionalDirectors().toPromise();
      this.FunctionalDirectors = <Profile[]>directors.responseData;
  
      
      let plantManager = await this.userService.getManagersUsers().toPromise();
      this.PlantManagers = <Profile[]>plantManager.responseData;
  
    }
  
    onSubmit(): void {
  
      this.clicked = true;
         let req : string[] = [];
         let selectedReqVal = Object.values(this.systemRequirements),
         selectedReqKeys = Object.keys(this.systemRequirements);
  
         selectedReqVal.forEach((x:any,i:number) =>{
         if(x) req.push(selectedReqKeys[i])
         })
         let systemRequired = req.join(',');
         
           if(this.modeOfRecruitment == "FTE")
            debugger
             let reqFte : string[] = [];
             let selectedReqValFte = Object.values(this.FTERequirements),
             selectedReqKeysFte = Object.keys(this.FTERequirements);
     
             selectedReqValFte.forEach((x:any,i:number) =>{
             if(x) reqFte.push(selectedReqKeysFte[i])
             })
             let fteRequired = reqFte.join(',');
           fteRequired == this.modeOfRecruitment
  
          if(this.selectedPlantManagerId != ''){
            this.IsPlantManagerToApprove = true
           
          }
        
         if(this.otherReasonForVacancy != '') this.reasonForVacancy = this.otherReasonForVacancy
        let ManpowerRequestVM: ManpowerRequestVM = {
        requesterDesignation: this.designation,
        requesterName: this.requesterName,
        requesterFunction: this.selectedDepartmentId,
        requesterUnit: this.selectedFunctionId,
        requestDate: this.requestDate,
        jobTitle: this.jobTitle,
        JobDescription: {
          RequestId: 0,
          DocumentName: this.file.name,
          DocumentContent: this.DocumentContent,
          ContentType: (this.ManPowerService.fileExtention(this.file.name)).toLowerCase(),
          DocumentDescription: this.documentDescription,
         },
        nPlus1Designation: this.nPlusOneDsignation,
        band: this.Band,
        costCenter: this.selectedCostCenterId,
        location: this.selectedLocationId,
        dateVacancyOccurred: this.dateVacancyOccured,
        requiredNumber: this.requiredNumber,
        typeOfVacancy: this.typeOfVacancy,
        reasonForVacancy: this.reasonForVacancy,
        modeOfRecruitment: fteRequired != ""  ? fteRequired : this.modeOfRecruitment,
        durationOfContract: this.durationofcontract,
        estimatedAnnualCost: this.estimatedcost,
        justificationForVacancy: this.justification,
        qualification: this.educationalqualification,
        skillsRequired: this.skillsrequired,
        experience: this.experience,
        systemRequired:systemRequired,
        otherSystemRequirements:this.otherRequirements ,
        functionDirectorToApprove: this.selectedfunctionalDirectorId,
        IsPlantManagerToApprove:this.IsPlantManagerToApprove,
        PlantManagerToApprove:this.selectedPlantManagerId,
        hrbpToApprove: this.selectedhrbpId,
        unitHeadToApprove: this.selectedManagerId,
         ohrdToApprove: this.ohrdToApprove,
        CeoToApprove: this.ceoToApprove
      };
      
      
          this.ManPowerService.saveManPower(ManpowerRequestVM).subscribe({
            next: (data => {
              debugger
              if (data.responseCode == "00") {
                this.notification.sendMessage({
                  message: `Request created successfully`,
                  type: NotificationType.success
                });
              
                this.ManPowerDraftsService.deleteManPowerDraft(this.draftId).subscribe();
                this.theForm.resetForm();    
                this.clicked = false;
              }
              else {
      
                this.notification.sendMessage({
                  message: data.message,
                  type: NotificationType.error
                  
                });
                this.clicked = false;
      
              }
      
            }),
            error: ((error: any) => {
              console.log(error.error);
           
              this.notification.sendMessage({
                message: error.error.message,
                type: NotificationType.error
              });
              this.clicked = false;
      
            })
      
          });
      
        }
  
        SaveDraft(): void {
          
          this.clicked = true;
             let req : string[] = [];
             let selectedReqVal = Object.values(this.systemRequirements),
             selectedReqKeys = Object.keys(this.systemRequirements);
      
             selectedReqVal.forEach((x:any,i:number) =>{
             if(x) req.push(selectedReqKeys[i])
             })
             let systemRequired = req.join(',');
             
               if(this.modeOfRecruitment == "FTE")
                debugger
                 let reqFte : string[] = [];
                 let selectedReqValFte = Object.values(this.FTERequirements),
                 selectedReqKeysFte = Object.keys(this.FTERequirements);
         
                 selectedReqValFte.forEach((x:any,i:number) =>{
                 if(x) reqFte.push(selectedReqKeysFte[i])
                 })
                 let fteRequired = reqFte.join(',');
               fteRequired == this.modeOfRecruitment
      
              if(this.selectedPlantManagerId != ''){
                this.IsPlantManagerToApprove = true
               
              }
            
             if(this.otherReasonForVacancy != '') this.reasonForVacancy = this.otherReasonForVacancy
            let ManpowerRequestVM: ManpowerRequestVM = {
            requesterDesignation: this.designation,
            requesterName: this.requesterName,
            requesterFunction: this.selectedDepartmentId,
            requesterUnit: this.selectedFunctionId,
            requestDate: this.requestDate,
            jobTitle: this.jobTitle,
            JobDescription: this.file ? {
                        RequestId: 0,
                        DocumentName: this.file.name,
                        DocumentContent: this.DocumentContent,
                        ContentType: (this.ManPowerDraftsService.fileExtention(this.file.name)).toLowerCase(),
                        DocumentDescription: this.documentDescription,
                       } : undefined,
            nPlus1Designation: this.nPlusOneDsignation,
            band: this.Band,
            costCenter: this.selectedCostCenterId,
            location: this.selectedLocationId,
            dateVacancyOccurred: this.dateVacancyOccured,
            requiredNumber: this.requiredNumber,
            typeOfVacancy: this.typeOfVacancy,
            reasonForVacancy: this.reasonForVacancy,
            modeOfRecruitment: fteRequired != ""  ? fteRequired : this.modeOfRecruitment,
            durationOfContract: this.durationofcontract,
            estimatedAnnualCost: this.estimatedcost,
            justificationForVacancy: this.justification,
            qualification: this.educationalqualification,
            skillsRequired: this.skillsrequired,
            experience: this.experience,
            systemRequired:systemRequired,
            otherSystemRequirements:this.otherRequirements ,
            functionDirectorToApprove: this.selectedfunctionalDirectorId,
            IsPlantManagerToApprove:this.IsPlantManagerToApprove,
            PlantManagerToApprove:this.selectedPlantManagerId,
            hrbpToApprove: this.selectedhrbpId,
            unitHeadToApprove: this.selectedManagerId,
             ohrdToApprove: this.ohrdToApprove,
            CeoToApprove: this.ceoToApprove
          };
          
          
              this.ManPowerDraftsService.updateManPower(ManpowerRequestVM).subscribe({
                next: (data => {
                  debugger
                  if (data.responseCode == "00") {
                    this.notification.sendMessage({
                      message: `Draft saved successfully`,
                      type: NotificationType.success
                    });
                  
          
                    // this.theForm.resetForm();    
                    this.clicked = false;
                  }
                  else {
          
                    this.notification.sendMessage({
                      message: data.message,
                      type: NotificationType.error
                      
                    });
                    this.clicked = false;
          
                  }
          
                }),
                error: ((error: any) => {
                  console.log(error.error);
               
                  this.notification.sendMessage({
                    message: error.error.message,
                    type: NotificationType.error
                  });
                  this.clicked = false;
          
                })
          
              });
          
            }
        
        onChangeDesignation(event:string)
        {
         
         const recruitment:string=(event);
         if(event ==""){ this.isreasonForVacancyVisible=false;
          this.isreasonForVacancy=false;}
         let item = this.ModeOfrecRuitment.find(i => i.modeofrecruitments === recruitment);
     
     if(item?.modeofrecruitments=== "FTE")
     {
       this.isreasonForVacancyVisible=true;
       this.isreasonForVacancy=false;
     }
    //  else
    //  {
    //    this.isreasonForVacancyVisible=false;
    //  }
     
     if(item?.modeofrecruitments=== "FTC")
     {
     this.isreasonForVacancy = true;
     this.isreasonForVacancyVisible=false;
     }
    
  
     if(item?.modeofrecruitments=== "CONSULTANT")
     {
     this.isreasonForVacancy = true;
     this.isreasonForVacancyVisible=false;
     }
    //  else
    //  {
    //    this.isreasonForVacancy=false;
    //  }
  
     if(item?.modeofrecruitments=== "INTERNSHIP")
     {
     this.isreasonForVacancy = true;
     this.isreasonForVacancyVisible=false;
     
     }
    //  else
    //  {
    //    this.isreasonForVacancy=false;
    //  }
      }
  
  
      onChangeFunction(event:string)
      {
       
       const manPowerfunction:string=(event);
       let item = this.Departments.find(i => i.name === manPowerfunction);
   
   if(item?.name=== "INDUSTRIAL")
   {
     this.isShowPlantManager=true;
     this.funcdirectorCount = 3
     this.hrbpCount = 4
     this.hrCount = 5
     this.ceoCount = 6
    
   }
   else{
    this.isShowPlantManager=false;
    this.funcdirectorCount = 2
    this.hrbpCount = 3
    this.hrCount = 4
    this.ceoCount = 5
  
   }
  }
    async onChangeDepartment(event:string)
    {
   /*
   const dptId:number=parseInt(event);
   
   let functions = await this.functionService.getByDepartmentId(dptId).toPromise();
   this.Functions = <FunctionDto[]>functions.res
   */
     }
  

}
